import type { Country as CountryType, TrackedTranslation } from '@ps/web-core-intl';
import type { ClassNameProp } from '@ps/web-shared-components';
import { Translation } from '@ps/web-shared-components';
import { Label } from '@ps/web-shared-ui';
import React from 'react';

import flags from '@swf/core/assets/flags';
import type { OnClickProp } from '@swf/core/types/Props';

import ListItem from '../../../ListItem/ListItem';

import { flag, flagContainer, labelContent } from './Country.scss';

interface Props extends Partial<ClassNameProp>, OnClickProp, CountryType, React.PropsWithChildren {
  selected?: boolean;
  disableRipple?: boolean;
  label?: TrackedTranslation;
}

const Country: React.FC<Props> = ({ value, text, className, label, ...props }) => (
  <>
    {label && (
      <Label id="identity-citizenship" className={labelContent}>
        <Translation {...label} />
      </Label>
    )}
    <ListItem
      primary={text}
      classes={{ avatar: flag, avatarContainer: flagContainer, selected: className }}
      avatarURL={flags[value]}
      {...props}
    />
  </>
);
export default Country;
